import React, { memo, useCallback, useEffect, useState } from 'react';

import { Checkbox } from '@components/common';

import { ECheckboxSizes } from '@components/common/Checkbox/Checkbox.types';

import { bandColorOptions, DEFAULT_COLOR_ID } from './constants';

import styles from './SectorsSettingsForm.module.scss';

interface ISectorColorSelectorProps {
	onChange: (colorId: string | number) => void;
	defaultColorId?: string | number;
}

const SectorColorSelector = ({
	onChange,
	defaultColorId,
}: ISectorColorSelectorProps) => {
	const [activeItem, setActiveItem] = useState(DEFAULT_COLOR_ID);

	const handleColorChange = useCallback((name: string) => () => {
		setActiveItem(name);
		onChange(name);
	}, [onChange]);

	useEffect(() => {
		if (defaultColorId !== undefined) {
			setActiveItem(String(defaultColorId));
		}
	}, [defaultColorId]);

	return (
		<div className={styles.colorCheckboxContainer}>
			<div className={styles.title}>Choose the sectors color on the MAP view</div>
			<div className={styles.colors}>
				{bandColorOptions.map((option) => {
					return (
						<Checkbox
							key={option.color}
							checked={activeItem === `${option.name}`}
							color={option.color}
							isFilledStyle
							name={option.name.toString()}
							onChange={handleColorChange(option.name.toString())}
							size={ECheckboxSizes.lg}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default memo(SectorColorSelector);
